import { z } from "zod";

export const consent = z.object({
  id: z.string(),
  href: z.string().optional(),
  userId: z.string().optional(),
  consentId: z.string(),
  consentTitle: z.string().optional(),
  consentText: z.string().optional(),
  accepted: z.boolean(),
  createdDate: z.string().optional(),
  lastModified: z.string().optional(),
  consentVersion: z.number(),
});

export const serverResponse = z.array(consent);
export type IUserConsent = z.infer<typeof consent>;
